
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-before-confirm",
      function () {
        return require("private-next-pages/account-before-confirm.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account-before-confirm"])
      });
    }
  